export enum ErrorMessage {
  Empty = ' ',
  Required = 'required',
  CheckRequired = 'checkrequired',
  Name = 'invalid.name',
  NRIC = 'invalid.nric',
  StateCode = 'invalid.stateCode',
  Last4Digits = 'invalid.last4Digits',
  Email = 'invalid.email',
  Mobile = 'invalid.mobile',
  Employer = 'invalid.employer',
  Income = 'invalid.income',
  Postcode = 'invalid.postcode',
  MinLength = 'invalid.minLength',
  MaxLength = 'invalid.maxLength',
  isBelow = 'invalid.isBelow',
  MaxFileSize = 'invalid.maxFileSize',
  UnsupportedFileType = 'invalid.unsupportedFileType',
  DuplicatedName = 'invalid.duplicateName',
  AccountNo = 'invalid.accountNo',
  BankAccountNumber = 'invalid.bankAccountNumber',
  Height = 'invalid.height',
  Weight = 'invalid.weight',
  AlphaNumeric = 'invalid.alphaNumeric',
}

export enum ErrorCode {
  ErrorAgeMin = 'LVE-20001',
  ErrorAgeMax = 'LVE-20002',
  ErrorDangerousOccupation = 'IVE-30001',
  Ape_Decline = 'UW033',
}

export enum ErrorCodePrefix {
  DVE = 'DVE', // Data Validation Error
  IVE = 'IVE', // Integration Validation Error
  SVE = 'SVE', // System Validation Error
  LVE = 'LVE', // Logic Validation Error
}
